import { useEffect, useState } from "react"
import { dataDecrypt, encrypt } from "../../../app/utility/encryption-helper";
import { ApisService } from "../../../app/core/apis.service";
import { useParams } from "react-router-dom";
import { Breadcrumb } from "../../../components/breadcum";
import { FormatIndianDate } from "../../../app/utility/formatIndianDate";
import { IMAGE_PATH } from "../../../config";
import ON_IMAGE from "../../../assets/images/no-image.webp"

export const TransactionInvoiceData = () => {
    const params = useParams();
    const [loading, setLoading] = useState<boolean>(false);
    const [invoiceData, setInvoiceData] = useState<any>();
    // const [show, setShow] = useState<boolean>(false);

    useEffect(() => {
        getRetailInvoices({ id: params.id })
    }, []);
    async function getRetailInvoices(data: any): Promise<void> {
        setLoading(true);
        try {
            let encrytedData = encrypt(JSON.stringify(data));
            const res = await ApisService.transactionApi("finInvoiceById", encrytedData);
            const TransactionData = JSON.parse(dataDecrypt(res.data.data));
            TransactionData.forEach((el: any) => {
                el.pendingAmount = el?.invoice_details?.paid_amount?.reduce((sum: any, item: any) => sum + item.value, 0) || 0
            })
            console.log(TransactionData[0], "TransactionData[0]");
            setInvoiceData(TransactionData[0]);
            setLoading(false);
        }
        catch (error) {
            setLoading(false);
        }
    }
    const breadcrumbInfo = [
        {
            label: "Transaction Invoices",
            value: "Transaction Invoices",
            routerLink: `/dashboard/organizations/org-details/${params.page}/${params.org}/transaction`,
            isActive: false,
        },
        {
            label: params.id,
            value: params.id,
            routerLink: ``,
            isActive: true,
        },
    ];

    return (
        <div className="container-fluid content-bg-color">
            <Breadcrumb breadCrumbList={breadcrumbInfo}></Breadcrumb>
            {loading && <div className="text-center p-5"><div className="spinner-border" role="status"><span className="sr-only"></span></div></div>}
            {!loading && <div className="card">
                <div className="card-body">
                    <h5 className="fw-bold primary-color mb-0">Basic Details</h5>
                    <div className="row">
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Invoice Number</div>
                            <div>{invoiceData?.invoice_number > 10 ? invoiceData?.invoice_number : `0${invoiceData?.invoice_number}`}</div>
                        </div>
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Transaction Id</div>
                            <div>{invoiceData?.transactionId}</div>
                        </div>
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Seller Name</div>
                            <div>{invoiceData?.seller?.name}</div>
                        </div>
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Seller Contact</div>
                            <div>{invoiceData?.seller?.contact_number}</div>
                        </div>
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Buyer Name</div>
                            <div>{invoiceData?.buyer?.name}</div>
                        </div>
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Buyer Contact</div>
                            <div>{invoiceData?.buyer?.contact_number}</div>
                        </div>
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Created Date</div>
                            <div>{FormatIndianDate(invoiceData?.invoice_details?.invoice_date, "")}</div>
                        </div>
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Invoice Amount</div>
                            <div>₹ {invoiceData?.invoice_details?.invoice_amount}</div>
                        </div>
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Paid Amount</div>
                            <div>₹ {invoiceData?.pendingAmount}</div>
                            {/* {invoiceData?.pendingAmount > 0 && <button className="primary-bg text-white rounded primary-border w-50 py-1 my-2" onClick={() => { showPopup() }}>History</button>} */}
                        </div>
                    </div>

                    <h5 className="primary-color fw-bold">Product Details</h5>
                    {invoiceData?.invoice_details?.products?.map((value:any,index:any)=>(
                        <div className="card mb-2" key={index}>
                            <div className="card-body">
                                <div className="row align-items text-center">
                                    <div className="col-md-1">
                                        <img src={`${value.product_image? IMAGE_PATH + '/' + value.product_image : ON_IMAGE}`} alt="product Image" className="w-100-h-100"/>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="fw-bold">{value?.product_name}</div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="fw-bold">Quantity</div>
                                        {value?.quantity}
                                    </div>
                                    <div className="col-md-2">
                                        <div className="fw-bold">Batch No</div>
                                        {value?.batch_number}</div>
                                    <div className="col-md-2">
                                        <div className="fw-bold">Unit Price</div>
                                        ₹ {value?.unit_price}
                                    </div>
                                     <div className="col-md-2">
                                        <div className="fw-bold">Sale Price</div>
                                        ₹ {value?.unit_price * value?.quantity}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>}
        </div>
    )
}